{
  "footer": {
    "navigation": "Alatunniste",
    "socialMedia": "Sosiaalinen media",
    "newTab": "(avautuu uuteen välilehteen)",
    "pdfDocument": "(PDF)",
    "social": {
      "facebook": "GlobalConnect Facebookissa",
      "youtube": "GlobalConnect YouTubessa",
      "linkedin": "GlobalConnect LinkedInissä",
      "instagram": "GlobalConnect Instagramissa"
    },
    "se": {
      "menus": {
        "globalConnect": "GlobalConnect",
        "purchaseInformation": "Ostotiedot",
        "customerService": "Asiakaspalvelu"
      },
      "links": {
        "aboutUs": "Tietoa GlobalConnectista",
        "euProjects": "EU-rahoitteiset hankkeet",
        "privacyPolicy": "Tietosuojakäytäntö",
        "cookiePolicy": "Evästekäytäntö",
        "career": "Ura",
        "press": "Medialle",
        "terms": "Yleiset ehdot",
        "fiberInterest": "Kuidun kiinnostusilmoitus",
        "leisureHomeServices": "Vapaa-ajan asunnon palvelut",
        "faq": "Usein kysyttyä",
        "contact": "Ota yhteyttä",
        "serviceStatus": "Häiriötiedotteet",
        "landowners": "Maanomistajat",
        "accessibility": "Saavutettavuus"
      }
    },
    "fi": {
      "menus": {
        "globalConnect": "GlobalConnect",
        "support": "Tuki",
        "termsAndPricing": "Ehdot ja hinnasto"
      },
      "links": {
        "aboutUs": "Meistä",
        "career": "Ura",
        "news": "Uutiset",
        "media": "Medialle",
        "sustainability": "Vastuullisuus",
        "businessCustomers": "Yritysasiakkaat",
        "customerService": "Asiakaspalvelu",
        "faq": "Usein kysyttyä",
        "cancellationForm": "Peruutuslomake",
        "serviceStatus": "Häiriötiedotteet",
        "cableInformation": "Kaapelitiedot",
        "accessibility": "Saavutettavuus",
        "priceList": "Hinnasto",
        "salesTerms": "Myyntiehdot",
        "serviceTerms": "Palveluehdot",
        "privacyPolicy": "Tietosuojakäytäntö",
        "cookiePolicy": "Evästekäytäntö"
      }
    }
  },
  "errorComponent": {
    "404": "Etsimääsi sivua ei näytä olevan olemassa.",
    "409": "Tämä osoite on jo yhdistetty ja valmis!",
    "500": "Hups, valitettavasti jotain meni pieleen!",
    "503": "Hups, jotain meni pieleen!",
    "statusFallback": "Hups, jotain meni pieleen.",
    "buttonTextPublicUrl": "Palaa kotisivullemme napsauttamalla tätä",
    "buttonTextPortalUrl": "Palaa takaisin napsauttamalla tätä"
  },
  "addressComponent": {
    "yourAddress": "Osoitteesi",
    "searchNewAddress": "Etsi uusi osoite"
  },
  "addressInfoTranslations": {
    "street": {
      "label": "Katuosoite",
      "placeholder": "Katuosoite"
    },
    "postalCode": {
      "label": "Postinumero",
      "placeholder": "Postinumero",
      "error": {
        "pattern": "Postinumeron on oltava 5 numeroa pitkä"
      }
    },
    "city": {
      "label": "Kaupunki",
      "placeholder": "Kaupunki"
    },
    "country": "Maa",
    "countryCode": {
      "error": {
        "pattern": "Väärä maakoodi"
      }
    },
    "countries": {
      "sweden": "Ruotsi",
      "norway": "Norja",
      "aland": "Ahvenanmaa"
    },
    "requiredError": "Tämä kenttä on pakollinen.",
    "sameBillingAddress": "Laskutusosoite on sama kuin toimitusosoite"
  },
  "commonInfoTranslations": {
    "phoneNumber": {
      "label": "Puhelinnumero",
      "countryCodeTitle": "Maatunnus",
      "placeholder": {
        "+46": "9 numeroa, esimerkki: 701234567",
        "+47": "8 tai 12 numeroa pitkä",
        "+358": "401234567",
        "+999": "+xxx xxxxxxxxx"
      },
      "error": {
        "pattern": "Vain numerot sallittu",
        "lengthNine": "Puhelinnumeron on oltava 9 numeroa pitkä",
        "lengthEightOrTwelve": "Puhelinnumeron on oltava 8 tai 12 numeroa pitkä",
        "lengthFiveToTen": "Puhelinnumeron on oltava 5–10 numeroa pitkä.",
        "otherCountryCode": "Syötä numero muodossa +358..."
      }
    },
    "email": {
      "label": "Sähköpostiosoite",
      "placeholder": "etunimi.sukunimi@email.fi",
      "error": {
        "notMatching": "Sähköpostiosoitteet eivät täsmää.",
        "pattern": "Ilmoita sähköpostiosoite muodossa esimerkki@email.fi"
      }
    },
    "confirmEmail": "Toista sähköpostiosoite",
    "requiredError": "Tämä kenttä on pakollinen."
  },
  "earliestActivationDateTranslations": {
    "earliestActivationDate": "Varhaisin aktivointipäivä",
    "toolTipInfo": "Varhaisin alkamispäivä määräytyy sen perusteella, onko osoitteessa aktiivisia palveluita tänään. Voi olla sitova jakso, joka estää halutun alkamispäivämäärän. Tarkistaaksesi mahdollisuudet siirtyä alkamispäivämäärää eteenpäin ottamalla yhteyttä valittuun toimittajaan, kun olet täyttänyt Tilaus."
  }
}
